import styled from "@emotion/styled";

export const Root = styled.div(({ theme }) => ({
    fontSize: theme.candy.typography.primary.fontSize.css(),
}));
